import ContractTaxiDriverAddRequest, {
  ContractTaxiDriverAddRequestBody,
} from "./contracts-taxi-driver-add.request";

const createBody = (
  request: ContractTaxiDriverAddRequest,
): ContractTaxiDriverAddRequestBody => {
  return {
    description: request.description,
    disabled: request.disabled,
    distanceRate: request.distanceRate,
    haltingTimeAfterMinutes: request.haltingTimeAfterMinutes,
    haltingTimeRate: request.haltingTimeRate,
    model: request.model,
    taxiDriverAssociationId: request.taxiDriverAssociationId,
    validSince: request.validSince,
    validTo: request.validTo,
  };
};

const contractsTaxiDriverAddRequestFactory = {
  createBody,
};

export default contractsTaxiDriverAddRequestFactory;
